import { Component, OnInit } from '@angular/core'
import { orderDetailsModel } from '../../models/order.model'
import { environment } from 'src/environments/environment'
import { TranslateService } from '@ngx-translate/core'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { UpdateOrderStatusPopupComponent } from '../../components/update-order-status-popup/update-order-status-popup.component'
import { SharedService } from 'src/app/shared/services/shared.service'
import { Subscription } from 'rxjs'
import { StoreService } from '../../services/store.service'
import { OrderStatus, PaymentStatus } from '../../models/order.enum'
import { ActivatedRoute } from '@angular/router'

@Component({
	selector: 'app-order-details',
	templateUrl: './order-details.component.html',
	styleUrl: './order-details.component.scss',
})
export class OrderDetailsComponent implements OnInit {
	attachmentLink = environment.attachmentPath
	Subscription = new Subscription()
	orderDeliverStatus = this.SharedService.returnEnumArray(OrderStatus)
	orderPaymentEnum = this.SharedService.returnEnumArray(PaymentStatus)
	id!: string
	orderDetails!: orderDetailsModel

	constructor(
		public translate: TranslateService,
		private dialog: MatDialog,
		private SharedService: SharedService,
		private StoreService: StoreService,
		private route: ActivatedRoute
	) {}
	ngOnInit(): void {
		this.id = this.route.snapshot.paramMap.get('id') as string
		this.SharedService.headerTitle.next('HEADER.ORDER_INFORMATION')
		this.getOrderDetails()
	}
	statusHistoryImage(status: number) {
		let image = ''
		switch (status) {
			case 1:
				image = './assets/images/bag.svg'
				break
			case 2:
				image = './assets/images/clock.svg'
				break
			case 3:
				image = './assets/images/tick-circle.svg'
				break
			case 4:
				image = './assets/images/bag-tick.svg'
				break
			case 5:
				image = './assets/images/truck-fast.svg'
				break
			case 6:
				image = './assets/images/truck-tick.svg'
				break
			case 7:
				image = './assets/images/close-circle-black.svg'
				break
			case 8:
				image = './assets/images/empty-wallet-time.svg'
				break
			case 9:
				image = './assets/images/empty-wallet-change.svg'
				break

			default:
				break
		}
		return image
	}
	cancelAction() {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '600px',
				height: '500px',

				data: {
					hasInput: true,
					label: 'GENERAL_LABELS.REASON',
					msgStyle: ' text-medium-gray text-font-14',
					image: './assets/images/note2.svg',
					notflex: true,
					confirmBtnStyle: `bg-gradient rounded-6px text-off-white`,
					cancelBtnStyle: ` border-[1px] border-secondry-color-Gray text-dark-grey border-solid`,
					title: `STORE.UPDATE_STATUS_POPUP.CANCEL_ORDER`,
					titleStyle: 'text-font-24 font-DIN-bold font-bold text-dark-grey',
					message: this.translate.instant(
						'CONFIRMATION_MESSAGE.CANCEL_ORDER_MSG',
						{
							orderNumber: this.orderDetails?.serialNumber,
						}
					),

					cancelBtn: 'ACTIONS.DISCARD',
					confirmBtn: 'ACTIONS.CANCEL_ORDER',
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						let body = {
							orderId: Number(this.id),
							orderStatusFrom: this.orderDetails?.orderStatus,
							orderStatusTo: 7,
							reason: res?.msg,
							date: res?.date,
							awb: res?.awb,
							countryId: this.orderDetails.countryId,
						}
						this.Subscription.add(
							this.StoreService.changeOrderStatus(body).subscribe((res) =>
								this.getOrderDetails()
							)
						)
					}
				},
			})
	}
	updateStatus() {
		this.dialog
			.open(UpdateOrderStatusPopupComponent, {
				width: '600px',
				height: '450px',
				autoFocus: false,
				data: {
					enums: this.orderDetails?.targetedStatuses,
					current: this.orderDetails?.orderStatus,
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						let body = {
							orderId: Number(this.id),
							orderStatusFrom: this.orderDetails?.orderStatus,
							orderStatusTo: res?.newStatus?.value,
							reason: res?.reason,
							date: res?.date,
							awb: res?.awb,
							countryId: this.orderDetails.countryId,
						}

						this.Subscription.add(
							this.StoreService.changeOrderStatus(body).subscribe((res) =>
								this.getOrderDetails()
							)
						)
					}
				},
			})
	}
	getOrderDetails() {
		this.Subscription.add(
			this.StoreService.getOrderDetails(this.id).subscribe({
				next: (res: any) => {
					this.orderDetails = res.result
					console.log(this.orderDetails)
				},
				error: () => {
					console.error('invalid api')
				},
			})
		)
	}
}
